import { CalendarIcon } from '@heroicons/react/24/solid';
import React, { forwardRef } from 'react';
import { Button } from 'react-daisyui';
import DatePicker from 'react-datepicker';
import { CustomInputProps } from '../Calendar.types';

const CalendarDatepicker = forwardRef<HTMLButtonElement, CustomInputProps>(
  function CustomInput(props, ref) {
    return (
      <Button color="ghost" onClick={props.onClick} ref={ref} className="p-1 ">
        <CalendarIcon className="h-8 w-8" />
      </Button>
    );
  },
);

export function HeaderDatePicker({ ...props }): React.ReactElement {
  return (
    <DatePicker
      className="form-input hidden-input"
      selected={props.currentDate}
      popperClassName="ReactDatepicker_Popper"
      wrapperClassName="ReactDatepicker_Wrapper"
      customInput={<CalendarDatepicker />}
      onChange={(val) => {
        props.onChangeDatepicker(val);
      }}
    />
  );
}
